import axios from 'axios';
import Vue from 'vue';
let retryCount = 0;
export const serverlessURL =
  // 'http://localhost:3000/dev';
  process.env.NODE_ENV === 'production'
    ? 'https://public-api.prd.medistream.co.kr/members/v2'
    : process.env.NODE_ENV === 'staging'
    ? 'https://public-api.stg.medistream.co.kr/members/v2'
    : 'https://public-api.dev.medistream.co.kr/members/v2';

export const comunityURL =
  process.env.NODE_ENV === 'production'
    ? 'https://public-api.medistream.co.kr/community/v2'
    : process.env.NODE_ENV === 'staging'
    ? 'https://public-api.stg.medistream.co.kr/community/v2'
    : 'https://public-api.dev.medistream.co.kr/community/v2';

// TODO: 추후에 auth에 staging환경이 생기면 auth.stg로 변경
const authUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://auth.medistream.co.kr'
    : process.env.NODE_ENV === 'staging'
    ? 'https://auth.medistream.co.kr'
    : 'https://auth.stg.medistream.co.kr';

// TODO: 추후에 auth에 staging환경이 생기면 stg clientId로 변경
const clientId =
  process.env.NODE_ENV === 'production'
    ? '01FSRJ9QBKT85VMM0RA4VC4FG3'
    : process.env.NODE_ENV === 'staging'
    ? '01FSRJ9QBKT85VMM0RA4VC4FG3'
    : '01FSKETD31BX4E4T5P6JGSACFM';
// ------------------------------------
const serverlessApi = axios.create({
  baseURL: serverlessURL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

const comunityApi = axios.create({
  baseURL: comunityURL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});
export const setToken = (accessToken, refreshToken, idToken) => {
  localStorage.setItem('accessToken', JSON.stringify(accessToken));
  localStorage.setItem('refreshToken', JSON.stringify(refreshToken));
  localStorage.setItem('idToken', JSON.stringify(idToken));
};
const removeToken = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('idToken');
};

const postRefresh = () => {
  console.log('refresh');
  const refreshToken = JSON.parse(localStorage.getItem('refreshToken'));
  if (refreshToken) {
    return serverlessApi.post('/auth/token', {
      refresh_token: refreshToken,
      type: 'combination',
      user_agent: window.navigator.userAgent,
    });
  }
};
// 토큰 로직 axios binding ----------------
export const login = (refer = null) => {
  const redirectUri = window.location.origin + '/auth/callback';
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));
  if (!accessToken) {
    // 로그아웃 한 경우에만 다른 계정으로 로그인하기 버튼이 렌더링 되도록 refer를 추가해준다.
    window.location.replace(
      `${authUrl}/login?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code` +
        (refer ? '&refer=logout' : ''),
    );
  }
};

export const logout = () => {
  // 토큰을 모두 지워 로그아웃을 한다.
  removeToken();
  // // Auth 서비스에서도 반드시 로그아웃을 한다. refer=logout 을 보내서 다른 계정으로 로그인이 가능하게 한다
  const redirectUri = window.location.origin + '/login?refer=logout';
  location.replace(`${authUrl}/logout?redirect_uri=${redirectUri}`);
};

const getToken = () => {
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));

  if (!accessToken) {
    login();
  }
  return accessToken;
};

const bindAccessToken = async config => {
  const accessToken = await getToken();
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${accessToken}`,
  };

  return config;
};

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

async function refreshTokenAndReattemptRequest(error) {
  const errorMsgTable = {
    502: '서버와의 연결이 끊어졌습니다. 잠시 후 다시 시도해 주세요.',
    504: '응답시간이 초과되었습니다. 잠시 후 다시 시도해 주세요.',
  };
  try {
    const { response: errorResponse } = error;
    const isFailed =
      errorResponse.status === 502 || errorResponse.status === 504;
    if (isFailed) {
      Vue.$toast.open({
        message: errorMsgTable[errorResponse.status],
        type: 'default',
        position: 'bottom',
        duration: 3000,
        // all of other options may go here
      });
      return;
    }
    const isRetry =
      errorResponse.status === 403 ||
      errorResponse.status === 401 ||
      errorResponse.status === 400;

    const isInvalidRefreshToken =
      errorResponse.data.message === 'invalid refresh token';
    if (isInvalidRefreshToken) {
      console.log('invalid refresh token');
      logout();
      return;
    }
    if (isRetry) {
      retryCount += 1;
      if (retryCount < 3) {
        // subscribers에 access token을 받은 이후 재요청할 함수 추가
        // retryOriginalRequest는 pending 상태로 있다가
        // access token을 받은 이후 onAccessTokenFetched가 호출될 때
        // access token을 넘겨 다시 axios로 요청하고
        // 결과값을 처음 요청했던 promise의 resolve로 settle시킨다.
        const retryOriginalRequest = new Promise((resolve, reject) => {
          addSubscriber(async accessToken => {
            try {
              errorResponse.config.headers['Authorization'] =
                'Bearer ' + accessToken;
              resolve(serverlessApi(errorResponse.config));
            } catch (err) {
              reject(err);
            }
          });
        });
        // refresh token을 이용해서 access token 요청
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true; // 문닫기 (한 번만 요청)
          const { data } = await postRefresh();
          const accessToken = data.results.access_token;
          const refreshToken = data.results.refresh_token;
          const idToken = data.results.id_token;
          setToken(accessToken, refreshToken, idToken);

          isAlreadyFetchingAccessToken = false; // 문열기 (초기화)
          retryCount = 0;
          onAccessTokenFetched(data.access);
        }
        return retryOriginalRequest; // pending 됐다가 onAccessTokenFetched가 호출될 때 resolve
      } else {
        logout();
      }
    }
  } catch (error) {
    console.log('[login failed] ==>', error);
    // logout();
    return Promise.reject(error);
  }
}
function addSubscriber(callback) {
  subscribers.push(callback);
}

function onAccessTokenFetched(accessToken) {
  subscribers.forEach(callback => callback(accessToken));
  subscribers = [];
}

// api.interceptors.request.use(bindAccessToken, Promise.reject);
// api.interceptors.response.use(null, refreshTokenAndReattemptRequest);
serverlessApi.interceptors.request.use(bindAccessToken, Promise.reject);
serverlessApi.interceptors.response.use(null, refreshTokenAndReattemptRequest);

comunityApi.interceptors.request.use(bindAccessToken, Promise.reject);
comunityApi.interceptors.response.use(null, refreshTokenAndReattemptRequest);

// ------------------------------------

export const combinationApi = {
  getHerbs() {
    // FIXME: 한약 제제는 수가 년도와 달라서 따로 설정이 필요합니다.
    // FIXME: 현재 기획과 디자인이 없고 한약제제 년도 선택할수 있는 UI/UX가 필요합니다.
    return serverlessApi.get('medicomb/herbs?referenceDate=2024-06-01');
  },
  searchCombination(referenceDate, body = {}) {
    return serverlessApi.post(
      `medicomb/search?referenceDate=${referenceDate}`,
      body,
    );
  },
  postCombination(body) {
    return serverlessApi.post('medicomb/combination', body);
  },
  getCombination(referenceDate) {
    return serverlessApi.get(
      `medicomb/combination?referenceDate=${referenceDate}`,
    );
  },
  deleteCombination(body) {
    return serverlessApi.post('medicomb/combination/delete', body);
  },
};

export const advertisementApi = {
  getAdvertisement() {
    return comunityApi.get('ads/campaign?name=pc_main_left_side_banner');
  },
};
